module.exports = __webpack_public_path__ + "img/ic-payment-ct-master.4e39e901.svg";